export default function ReturnsSection() {
  const returns = [
    {
      label: '超早割25%Off',
      title: 'Atelier Folio for iPad 1点',
      note: '※同色ペンホルダー1個付属',
      highlight: true,
      badge: '限定150名',
    },
    {
      label: '早割20%Off',
      title: 'Atelier Folio for iPad 1点',
      note: '※同色ペンホルダー1個付属',
      highlight: true,
      badge: '限定350名',
    },
    {
      label: 'Makuake限定',
      title: '追加ペンホルダーセット',
      note: '本体＋付属ペンホルダー1個＋追加ペンホルダー1個',
      highlight: false,
      badge: null,
    },
    {
      label: '2個セット割',
      title: '複数台利用者向け',
      note: null,
      highlight: false,
      badge: null,
    },
    {
      label: '3個セット割',
      title: '複数台利用者向け',
      note: null,
      highlight: false,
      badge: null,
    },
    {
      label: '4個セット割',
      title: '複数台利用者向け',
      note: null,
      highlight: false,
      badge: null,
    },
    {
      label: '5個セット割',
      title: '複数台利用者向け',
      note: null,
      highlight: false,
      badge: null,
    },
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* セクションタイトル */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
            <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">Returns</p>
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            リターンに<span className="text-[#8B6BAE]">ついて</span>
          </h2>
          <p className="text-base text-[#6B6B6B] font-light">
            ご支援いただける各プランをご紹介します
          </p>
        </div>

        {/* リターン一覧 */}
        <div className="space-y-3">
          {returns.map((item, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-xl p-5 border transition-all cursor-pointer group ${
                item.highlight 
                  ? 'border-[#8B6BAE]' 
                  : 'border-[#E8E8E8] hover:border-[#8B6BAE]/40'
              }`}
            >
              <div className="flex flex-col md:flex-row md:items-center gap-3">
                {/* ラベル */}
                <div className={`inline-flex items-center justify-center px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap ${
                  item.highlight 
                    ? 'bg-[#8B6BAE] text-white' 
                    : 'bg-[#F0EBF5] text-[#8B6BAE]'
                }`}>
                  {item.label}
                </div>

                {/* タイトルと説明 */}
                <div className="flex-1">
                  <h3 className="text-base font-medium text-[#2C2C2C]">{item.title}</h3>
                  {item.note && (
                    <p className="text-sm text-[#6B6B6B] mt-0.5">{item.note}</p>
                  )}
                </div>

                {/* 矢印 */}
                <div className="hidden md:flex w-8 h-8 items-center justify-center rounded-full bg-[#F0EBF5] text-[#8B6BAE] group-hover:bg-[#8B6BAE] group-hover:text-white transition-all">
                  <i className="ri-arrow-right-line text-base"></i>
                </div>
              </div>

              {/* バッジ */}
              {item.badge && (
                <div className="absolute -top-2 right-5">
                  <span className="inline-block bg-[#E8B4B8] text-white text-xs font-medium px-3 py-1 rounded-full">
                    {item.badge}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* 注意書き */}
        <div className="mt-10 text-center">
          <p className="text-sm text-[#9B9B9B]">
            ※詳細な価格および割引率は各リターン欄をご確認ください
          </p>
        </div>
      </div>
    </section>
  );
}
